import { PropsWithChildren } from "react";

import {
    SiteSelectorContextProvider,
    SiteSelectorContextProviderProps
} from "@/components/site-selector-modal/index.ts";

export interface OptionalSiteSelectorContextProviderProps
    extends PropsWithChildren {
    siteSelectorProductKey?: string;
    siteSelectorAnalyticsPrefix?: string;
}

export const OptionalSiteSelectorContextProvider = (
    props: OptionalSiteSelectorContextProviderProps
) => {
    const { siteSelectorProductKey, siteSelectorAnalyticsPrefix, children } =
        props;
    if (!siteSelectorProductKey) {
        return <>{children}</>;
    }

    return (
        <SiteSelectorContextProvider
            productKey={
                siteSelectorProductKey as SiteSelectorContextProviderProps["productKey"]
            }
            analyticsPrefix={
                siteSelectorAnalyticsPrefix ?? siteSelectorProductKey
            }
        >
            {children}
        </SiteSelectorContextProvider>
    );
};
